"use strict";
exports.__esModule = true;
exports.RateApi = void 0;
var env_1 = require("../../env");
var api = {
    get: function (sessionId) { return env_1.Env.Endpoint + "/" + sessionId + "/description/rates"; },
    getRate: function (sessionId, rateId) { return env_1.Env.Endpoint + "/" + sessionId + "/description/rates/" + rateId; }
};
exports.RateApi = api;
//# sourceMappingURL=rate.api.js.map